import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { TableBody } from "../../utils/PMTable/TableBody";
import { PMPagination } from "../../utils/PMPagination";
import { Link, Navigate, useNavigate } from "react-router-dom";
import {
  ChevronDownIcon,
  ChevronUpIcon,
} from "@heroicons/react/24/outline";
import imgPlaceholder from "../../../utils/img-placeholder.png";
import { ResourceLoading } from "../../utils/ResourceLoading";
import { ProductWarehouseStatus } from "./utils";
import { useSettings } from "../../../contexts/settings-context";
import { LoadingRows, StringLimit } from "../../Utils";
import { ResourceEmpty } from "../../utils/ResourceEmpty";
import { DocumentImage, DocumentImageOptimized } from "../documents/utils";
import { DocumentViewer } from "../Media/documentViewer";
const people = [
  {
    name: "Lindsay Walton",
    title: "Front-end Developer",
    email: "lindsay.walton@example.com",
    role: "Member",
  },
  // More people...
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export const ProductsTable = (props) => {
  const {
    itemState,
    onPageChange,
    itemsCount,
    currentCount,
    page,
    perPage,
    onItemsSelect,
    resetSelected,
    sortBy,
    sort,
    onSortChange,
  } = props;
  const { t } = useTranslation();
  const { data, isLoading, errors } = itemState;

  const checkbox = useRef();
  const [checked, setChecked] = useState(false);
  const [indeterminate, setIndeterminate] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);

  useEffect(() => {
    if (resetSelected) {
      setSelectedItems([]);
      setChecked(false);
      setIndeterminate(false);
    }
  }, [resetSelected]);

  useLayoutEffect(() => {
    const isIndeterminate =
      selectedItems.length > 0 && selectedItems.length < data.length;
    setChecked(selectedItems.length === data.length);
    setIndeterminate(isIndeterminate);
    checkbox.current.indeterminate = isIndeterminate;
    onItemsSelect(selectedItems);
  }, [selectedItems]);

  function toggleAll() {
    setSelectedItems(checked || indeterminate ? [] : data);
    setChecked(!checked && !indeterminate);
    setIndeterminate(false);
  }

  const navigate = useNavigate();

  const pagination = () => {};

  const { priceFormatter } = useSettings();

  const statuses = {
    "none": { label: "None", class: "bg-gray-100 text-black-800" },
    "active": { label: "Active", class: "bg-green-100 text-green-800" },
    "unpublished": { label: "Unpublished", class: "bg-red-600 text-white" },
  };

  const SortIcon = ({ column }) => {
    if (!onSortChange) return null;
    const isActive = sortBy === column;
    const isAsc = sort?.toLowerCase() === "asc";
    if (!isActive) return null;
    return isAsc ? (
      <ChevronUpIcon className="h-4 w-4 shrink-0 text-gray-500" />
    ) : (
      <ChevronDownIcon className="h-4 w-4 shrink-0 text-gray-500" />
    );
  };

  function renderRows() {
    return data?.map((item, index) => {
      return (
        <tr key={item.id}>
          <td className="relative px-7 sm:w-12 sm:px-6">
            {selectedItems.includes(item) && (
              <div className="absolute inset-y-0 left-0 w-0.5 bg-blue-400" />
            )}
            <input
              type="checkbox"
              className="absolute left-4 top-1/2 -mt-2 h-4 w-4 rounded border-gray-300 text-blue-400 focus:ring-blue-400"
              value={item.id}
              checked={selectedItems.includes(item)}
              onChange={(e) =>
                setSelectedItems(
                  e.target.checked
                    ? [...selectedItems, item]
                    : selectedItems.filter((p) => p !== item)
                )
              }
            />
          </td>
          <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm sm:pl-6">
            <div className="flex items-center">
              <div className="max-w-10 max-h-10">
                <DocumentImageOptimized document={item?.main_picture} />
              </div>
              <div className="ml-4">
                <Link
                  to={"/dashboard/products/" + item?.id}
                  className="text-blue-400"
                >
                  <div className="text-xs">{item.item_number}</div>
                  <div className="font-xl">
                    <StringLimit text={item?.title} limit={50} />
                  </div>
                </Link>
              </div>
            </div>
          </td>
          <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
            <div className="text-gray-500">{item?.brand?.title}</div>
          </td>
          <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
            <div className="text-gray-500 tabular-nums">
              {item?.model_year != null && item?.model_year !== ""
                ? item.model_year
                : "—"}
            </div>
          </td>
          <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
            <div className="text-gray-500">
              <ProductWarehouseStatus report={item} />
            </div>
          </td>
          <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
            {item?.status && (
              <span
                className={classNames(
                  statuses[item?.status].class,
                  "inline-flex rounded-full px-2 text-xs font-semibold leading-5"
                )}
              >
                {statuses[item?.status].label}
              </span>
            )}
          </td>

          <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
            {priceFormatter.format(item?.purchase_price)}
          </td>
          <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
            {priceFormatter.format(item?.sales_price)}
          </td>
        </tr>
      );
    });
  }

  // return (
  //   <>
  //     <PMPagination
  //       disabled={isLoading}
  //       onPageChange={onPageChange}
  //       page={page}
  //       perPage={perPage}
  //       rowsCount={itemsCount}
  //       totalCount={itemsCount}
  //       currentCount={currentCount}
  //       showCount={false}
  //     />
  //     <Table>
  //       <thead className="bg-gray-50">
  //         <tr>
  //           <th
  //             scope="col"
  //             className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
  //           ></th>
  //           <th
  //             scope="col"
  //             className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
  //           >
  //             Title
  //           </th>
  //           <th
  //             scope="col"
  //             className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
  //           >
  //             Stock
  //           </th>
  //           <th
  //             scope="col"
  //             className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
  //           >
  //             Status
  //           </th>
  //           <th
  //             scope="col"
  //             className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
  //           >
  //             Purchase Price
  //           </th>
  //           <th
  //             scope="col"
  //             className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
  //           >
  //             Sales Price
  //           </th>
  //           <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6">
  //             <span className="sr-only">Edit</span>
  //           </th>
  //         </tr>
  //       </thead>
  //       <TableBody>{!isLoading && data ? renderRows() : ""}</TableBody>
  //     </Table>
  //     <PMPagination
  //       disabled={isLoading}
  //       onPageChange={onPageChange}
  //       page={page}
  //       perPage={perPage}
  //       rowsCount={itemsCount}
  //       totalCount={itemsCount}
  //       currentCount={currentCount}
  //       showCount={true}
  //     />
  //   </>
  // );

  return (
    <div className="mt-8 flow-root">
      <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
          <div className="relative">
            <table className="min-w-full table-fixed divide-y divide-gray-300">
              <thead className="bg-gray-50">
                <tr>
                  <th scope="col" className="relative px-7 sm:w-12 sm:px-6">
                    <input
                      type="checkbox"
                      className="absolute left-4 top-1/2 -mt-2 h-4 w-4 rounded border-gray-300 text-blue-400 focus:ring-blue-400"
                      ref={checkbox}
                      checked={checked}
                      onChange={toggleAll}
                    />
                  </th>
                  <th
                    scope="col"
                    className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                  >
                    Number
                  </th>
                  <th
                    scope="col"
                    className="text-left text-sm font-semibold text-gray-900 pl-3"
                  >
                    Leverandør
                  </th>
                  <th
                    scope="col"
                    className={`text-left text-sm font-semibold text-gray-900 pl-3 ${
                      onSortChange
                        ? "cursor-pointer select-none hover:bg-gray-100"
                        : ""
                    }`}
                    onClick={() => onSortChange?.("model_year")}
                  >
                    <span className="inline-flex items-center gap-1">
                      {t("product.model_year")}
                      <SortIcon column="model_year" />
                    </span>
                  </th>
                  <th
                    scope="col"
                    className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                  >
                    Lager status
                  </th>
                  <th
                    scope="col"
                    className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                  >
                    Status
                  </th>
                  <th
                    scope="col"
                    className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                  >
                    Purchase Price
                  </th>

                  <th
                    scope="col"
                    className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                  >
                    Sales Price
                  </th>
                </tr>
              </thead>
              {/* <TableBody>{!isLoading && data ? renderRows() : ""}</TableBody> */}
              <TableBody>
                {isLoading ? (
                  <>
                    <LoadingRows cols={7} checkboxCell={true} />
                    <LoadingRows cols={7} checkboxCell={true} />
                    <LoadingRows cols={7} checkboxCell={true} />
                    <LoadingRows cols={7} checkboxCell={true} />
                    <LoadingRows cols={7} checkboxCell={true} />
                    <LoadingRows cols={7} checkboxCell={true} />
                    <LoadingRows cols={7} checkboxCell={true} />
                    <LoadingRows cols={7} checkboxCell={true} />
                    <LoadingRows cols={7} checkboxCell={true} />
                    <LoadingRows cols={7} checkboxCell={true} />
                  </>
                ) : data.length < 1 ? (
                  <tr>
                    <td colSpan={8} className="py-2 px-2">
                      <ResourceEmpty />
                    </td>
                  </tr>
                ) : (
                  renderRows()
                )}
              </TableBody>
            </table>

            <PMPagination
              disabled={isLoading}
              onPageChange={onPageChange}
              page={page}
              perPage={perPage}
              rowsCount={itemsCount}
              totalCount={itemsCount}
              currentCount={currentCount}
              showCount={true}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

ProductsTable.defaultProps = {
  page: 1,
  itemState: [],
  itemsCount: 0,
  selectedItems: [],
  sort: "desc",
  sortBy: "createdAt",
};
